module.exports = __webpack_public_path__ + "static/grafika1@2x-4118e6745fb33a2a46dc7e8ae08ceef4.png";